export const MWS_SYNC_COMPLETED = 'MWS - Completed Sync'
